import AppsContent from "@nxsys/components/AppsContainer/AppsContent";
// import CreateModal from "./CreateModal";
// import PreviewModal from "./PreviewModal";
import CreateAndViewKIDModal from "./CreateAndPreview/CreateAndViewKIDModal";
import { useDispatch } from "react-redux";
import { AppDispatch } from "@nxsys/store";
import { useEffect } from "react";
import { kidAction } from "@nxsys/store/slices/kid/kidSlice";

const KIDUmbrella = () => {
  const dispatch = useDispatch<AppDispatch>();
  useEffect(() => {
    dispatch(kidAction.resetPreview());
  }, []);
  return (
    <>
      <AppsContent>
      <CreateAndViewKIDModal />
      </AppsContent>
   
    </>
  );
};

export default KIDUmbrella;
